module.exports = __webpack_public_path__ + "static/media/Comp2.cce937c9.png";